import { AxiosError } from "axios";

import { getUserInternalAccessToken } from "@/api/access-token-backoffice";
import { gupshupIntegrationService } from "@/api/customer-platform/whatsapp/gupshup-integration";
import { apiT2B } from "@/lib/axios";

function decodeJWT(token: string): { exp?: number; iat?: number; [key: string]: any } | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) {
      return null;
    }
    const payload = parts[1];
    const decoded = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
    return decoded;
  } catch (error) {
    return null;
  }
}

function isTokenExpired(token: string): boolean {
  const decoded = decodeJWT(token);
  if (!decoded || !decoded.exp) {
    return true; 
  }
  const expirationTime = decoded.exp * 1000; 
  const now = Date.now();
  const margin = 5 * 60 * 1000; 
  return now >= (expirationTime - margin);
}

const GUPSHUP_EMAIL = "tecnologia@talk2buy.com.br";
const GUPSHUP_PASSWORD = "NIplTEZqO2bD0wYK34pDNRj7Y_HrYff33vKZAVL8P4sxYdXqN8JkKzVMbxqNvJAw";

export async function getPartnerToken(): Promise<string> {
  try {
    
    const { accessToken: internalAccessToken } = await getUserInternalAccessToken();

    const platformsResponse = await apiT2B.get("api/v1/platform", {
      headers: {
        Authorization: `Bearer ${internalAccessToken}`,
      },
      params: {
        pageNumber: 1,
        pageSize: 100,
      },
    });

    const whatsappBspPlatform = platformsResponse.data.items?.find(
      (p: { name: string }) => 
        p.name?.toUpperCase() === "WHATSAPP_BSP" || 
        p.name?.toUpperCase() === "GUPSHUP" ||
        p.name === "GUPSHUP"
    );

    if (whatsappBspPlatform?.appToken) {
      
      const tokenExpired = isTokenExpired(whatsappBspPlatform.appToken);
      
      if (!tokenExpired) {
        gupshupIntegrationService.setPartnerToken(whatsappBspPlatform.appToken);
        return whatsappBspPlatform.appToken;
      }
    }

    const newToken = await gupshupIntegrationService.login(GUPSHUP_EMAIL, GUPSHUP_PASSWORD);

    if (whatsappBspPlatform?.id) {
      try {
        
        const platformResponse = await apiT2B.get(`api/v1/platform/${whatsappBspPlatform.id}`, {
          headers: {
            Authorization: `Bearer ${internalAccessToken}`,
          },
        });

        const fullPlatform = platformResponse.data;

        const { id, rowDate, ...platformData } = fullPlatform;

        const name = platformData.name || whatsappBspPlatform.name || "GUPSHUP";
        const displayName = platformData.displayName || whatsappBspPlatform.displayName || "WhatsApp BSP";
        const type = platformData.type ?? whatsappBspPlatform.type ?? 1;
        const active = platformData.active ?? true;

        const formData = new FormData();
        formData.append("Name", name);
        formData.append("DisplayName", displayName);
        formData.append("Type", type.toString());
        formData.append("Active", active.toString());
        formData.append("AppToken", newToken);
        
        if (platformData.appKey) {
          formData.append("AppKey", platformData.appKey);
        }
        
        if (platformData.logoImage) {
          formData.append("LogoImage", platformData.logoImage);
        }

        await apiT2B.put(
          `api/v1/platform/${whatsappBspPlatform.id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${internalAccessToken}`,
              
            },
          }
        );
      } catch (updateError) {
        
      }
    }

    return newToken;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(
        `Failed to get partner token: ${error.response?.data?.message || error.message}`
      );
    }
    throw error;
  }
}
